import request from '@/plugins/axios'

//获取图片邀约列表
export function listPictureNeed(params) {
  return request({
    url: '/pictureNeed/listPictureNeed',
    method: 'get',
    params
  })
}

//添加图片邀约
export function addPictureNeed(data) {
  return request({
    url: '/pictureNeed/addPictureNeed',
    method: 'post',
    data
  })
}

//删除图片邀约
export function deletePictureNeed(params) {
  return request({
    url: '/pictureNeed/deletePictureNeed/' + params,
    method: 'get'
  })
}

//查询单个图片邀约
export function getPictureNeed(params) {
  return request({
    url: '/pictureNeed/getPictureNeed/' + params,
    method: 'get'
  })
}

//修改图片邀约信息
export function updatePictureNeed(data) {
  return request({
    url: '/pictureNeed/updatePictureNeed',
    method: 'post',
    data
  })
}

//获取指派给我的图片邀约
export function myPictureNeed(params) {
  return request({
    url: '/pictureNeed/myPictureNeed',
    method: 'post',
    params
  })
}


//添加图片邀约的图片关联
export function addAccess(data) {
  return request({
    url: '/pictureNeed/addAccess',
    method: 'post',
    data
  })
}

//批量添加图片邀约的图片关联
export function batchAccess(data) {
  return request({
    url: '/pictureNeed/batchAccess',
    method: 'post',
    data
  })
}

//获取图片邀约的图片信息
export function listAccess(params) {
  return request({
    url: '/pictureNeed/listAccess',
    method: 'get',
    params
  })
}

//触发邀约打包
export function completePictureNeed(params) {
  return request({
    url: '/pictureNeed/completePictureNeed',
    method: 'get',
    params
  })
}